module.exports = {
      id: "download-usage",
      viewBox: "0 0 24 24",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#download",
      toString: function () {
        return this.url;
      }
    }